class InfiniteScroll {
  constructor(sentinel) {
    this.sentinel = sentinel;
    this.sectionId = sentinel.dataset.sectionId;
    this.grid = document.getElementById('product-grid');
    this.loading = document.getElementById('InfiniteScrollLoading-' + this.sectionId);
    this.isLoading = false;

    if (!this.grid || !sentinel.dataset.nextUrl) return;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '600px 0px 600px 0px',
    });
    this.observer.observe(this.sentinel);
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.isLoading) {
        this.loadNextPage();
      }
    });
  }

  loadNextPage() {
    const nextUrl = this.sentinel.dataset.nextUrl;
    if (!nextUrl) {
      this.observer.unobserve(this.sentinel);
      return;
    }

    this.isLoading = true;
    if (this.loading) this.loading.hidden = false;

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', this.sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          Array.from(newGrid.children).forEach((child) => this.grid.appendChild(child));
        }

        const newSentinel = doc.getElementById('InfiniteScrollSentinel-' + this.sectionId);
        if (newSentinel && newSentinel.dataset.nextUrl) {
          this.sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
        } else {
          delete this.sentinel.dataset.nextUrl;
          this.observer.unobserve(this.sentinel);
        }

        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', nextUrl);
        }
      })
      .catch((error) => {
        console.error('Infinite scroll failed to load next page:', error);
        this.observer.unobserve(this.sentinel);
      })
      .finally(() => {
        this.isLoading = false;
        if (this.loading) this.loading.hidden = true;
      });
  }
}

document.querySelectorAll('.infinite-scroll__sentinel').forEach((sentinel) => {
  new InfiniteScroll(sentinel);
});